module.exports = __webpack_public_path__ + "static/media/furniture2.46c59bb5.jpg";